import axios from 'axios';

export default axios.create({
  baseURL: 'https://movies-api-tohd.onrender.com',
});